export default __webpack_public_path__ + "static/media/image-slider02.8641ea2b.jpg";